import React, {Component} from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from './../actions'
import SearchContainer from './../containers/site/search_container'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

// NOTE: BrandKey- / fw- のパスでは、フォームは描画されるが条件は復元されない
// (reducers/search_form_condition.js の getMergedPathnameState が未対応。ブランドは
// 復元するとブランド URL へ遷移し続ける問題があり意図的に見送られている)。
// これは react-router 6.2.2 固定時からの既存挙動で、この変更で持ち込んだものではない。
// 描画自体を止めると SEO ページから検索フォームが消えるため、挙動は維持する。

class SiteSearch extends Component {

  // 初期化時のトリガをここで行う
  componentWillMount() {
    this.props.actions.getSystemLabelMasters()
  }

  render() {
    return (
      <BrowserRouter>
        {/*
          SEO 用の絞り込みパスは、以前は '/site/items/BodyKeijou-:body_type' のように
          1 セグメント内で接頭辞とパラメータを混在させて列挙していた。react-router は
          この書き方を 6.2.2 までしか受け付けず、それ以降はどのパスにもマッチせず
          検索フォームが表示されなくなる (6.2.2 に固定していたのはこのため)。
          パラメータはどこでも参照していないので、セグメントを丸ごと受ける形に統合する。
          このルートは車両詳細 (/site/items/:id) にもマッチするが、マウント先の要素
          (id="js-search") が検索一覧の view にしか無いので詳細ページを巻き込むことはない
          (packs/site_items_search.js がその要素の有無で分岐する)。
        */}
        <Routes>
          <Route path={'/site/items'} element={<SearchContainer />} />
          <Route path={'/site/items/:filter'} element={<SearchContainer />} />
        </Routes>
      </BrowserRouter>
    )
  }
}

export default connect(null, mapDispatchToProps)(SiteSearch)
